import { Injectable } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import { ApiService } from '@shared/services';
import { Machine } from '@shared/entities/machine';

const LOG_PREFIX = '[Api][MachinesAccountIds] ';

@Injectable({
  providedIn: 'root'
})
export class MachinesAccountIdsService extends ApiService<Machine> {
  constructor() {
    const masterUrl = '/machines/accounts';
    const detailUrl = '/machines/accounts';
    super(Machine, masterUrl, detailUrl, undefined, 'machines-accounts');
  }

  getMachinesByAccountIds(accountIds: string[]): Observable<Machine[]> {
    if (!accountIds || accountIds.length === 0) {
      return of([]);
    }

    this.logger.debug(LOG_PREFIX + `getMachinesByAccountIds with accountIds: ${accountIds}`);
    this.setUrlParameter('accountIds', JSON.stringify(accountIds));

    return this.paginate(Machine, 1, 1000).pipe(
      map((response) => {
        this.logger.debug(LOG_PREFIX + 'getMachinesByAccountIds response', response);
        return response.data || [];
      }),
      catchError((error) => {
        this.logger.error(LOG_PREFIX + `Error getting machines for account IDs ${accountIds}:`, error);
        return of([]);
      })
    );
  }
}
